import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  grid-template-columns: repeat(4, 1fr);
  max-height: 100%;

  grid-gap: 8px;
  display: grid;
`;

interface ItemAttrubites {
  colorPicker?: boolean;
  isActive: boolean;
}

export const Item = styled.div(
  ({ colorPicker, isActive }: ItemAttrubites) => css`
    background-color: #ebebeb;
    border-radius: 8px;
    position: relative;
    padding-top: 100%;

    svg,
    & > img {
      transform: translate(-50%, -50%);
      position: absolute;

      max-height: 100%;
      max-width: 100%;

      left: 50%;
      top: 50%;
    }

    ${isActive &&
    css`
      box-shadow: 0px -4px 0px 0px rgb(0 0 0 / 0.3) inset;
      border: 2px solid ${Theme.color.orange};
      padding-top: calc(100% - 4px);

      ${colorPicker &&
      css`
        background-image: conic-gradient(
          from 180deg at 50% 50%,
          rgba(255, 0, 0, 0.6) 0deg,
          rgba(255, 214, 0, 0.6) 80.625deg,
          rgba(20, 255, 0, 0.6) 153.75deg,
          rgba(0, 102, 255, 0.6) 225deg,
          rgba(255, 0, 245, 0.6) 298.125deg,
          rgba(255, 0, 0, 0.6) 360deg
        );

        svg:first-child,
        & > img:first-child {
          opacity: 0.2;
        }

        svg:last-child {
          top: 55%;
        }

        /* First row (avoid tooltip overflow): */
        &:nth-child(-n + 4) > div:last-child {
          box-shadow: 0px 4px 0px 0px #7faab2;
          transform: translate(-50%, -50%);
          padding: 4px;

          &::before {
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            border-top: 12px solid #abe5f1;
          }

          &::after {
            border-right: 16px solid transparent;
            border-left: 16px solid transparent;
            border-top: 18px solid #7faab2;
          }
        }
      `}
    `}
  `
);
